import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from 'styled-components';

import {
  MasterListTableNoResultsWrapper,
  MasterListTableNoResultsText,
  MasterListTableWrapper,
  MasterListTableGridWrapper,
  MasterListTableHeader,
  MasterListTableDivider,
  MasterListTableItem,
  MasterListTableItemText,
  MasterListTableItemStatus,
  MasterListTableIconBtn,
} from './MasterListTable.style';

const MasterListTable = ({
  mappedMasterListList,
  stringsData,
  masterListStatusEnum,
  masterListStatusColorEnum,
  handleMasterListEditButtonClick,
}) => {
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const themeContext = useContext(ThemeContext);
  const { colors } = themeContext;
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  const masterListGridHeaderList = stringsData.masterListList.masterListGridHeader;
  if (mappedMasterListList.length === 0)
    return (
      <MasterListTableNoResultsWrapper>
        <MasterListTableNoResultsText>
          {stringsData.masterListList.masterListGridNoResultsFound}
        </MasterListTableNoResultsText>
      </MasterListTableNoResultsWrapper>
    );

  return (
    <MasterListTableWrapper>
      <MasterListTableGridWrapper>
        <MasterListTableDivider />
        {Object.keys(masterListGridHeaderList).map(masterListGridHeaderKey => (
          <MasterListTableHeader key={masterListGridHeaderKey}>
            {masterListGridHeaderList[masterListGridHeaderKey]}
          </MasterListTableHeader>
        ))}
        <MasterListTableDivider />
        {mappedMasterListList.map((masterList, index) => {
          const { color, backgroundColor } =
            masterListStatusColorEnum(colors)[masterList.IsSearchable] || {};
          const masterListEnglishDetails = masterList.ServiceTranslators.find(
            details => details.Culture === 'en-US',
          );
          const masterListArabicDetails = masterList.ServiceTranslators.find(
            details => details.Culture === 'ar-EG',
          );
          return (
            <React.Fragment key={masterList.ServiceKey}>
              <MasterListTableItem>
                <MasterListTableItemText>{masterListEnglishDetails.Name}</MasterListTableItemText>
              </MasterListTableItem>
              <MasterListTableItem>
                <MasterListTableItemText>{masterListArabicDetails.Name}</MasterListTableItemText>
              </MasterListTableItem>
              <MasterListTableItem>
                <MasterListTableItemStatus color={color} backgroundColor={backgroundColor}>
                  {masterListStatusEnum.getKeyByValue(masterList.IsSearchable)}
                </MasterListTableItemStatus>
              </MasterListTableItem>
              <MasterListTableItem>
                <MasterListTableItemText>
                  {`${masterList.ServicePrice} EGP`}
                </MasterListTableItemText>
              </MasterListTableItem>
              <MasterListTableItem>
                <MasterListTableIconBtn
                  icon={"'\\e90a'"}
                  onClick={() => handleMasterListEditButtonClick(masterList)}
                  data-testid={`EditMasterListBtn-${index}`}
                />
              </MasterListTableItem>
              <MasterListTableDivider />
            </React.Fragment>
          );
        })}
      </MasterListTableGridWrapper>
    </MasterListTableWrapper>
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

export default MasterListTable;

MasterListTable.propTypes = {
  stringsData: PropTypes.shape({
    masterListList: PropTypes.shape({
      masterListGridNoResultsFound: PropTypes.string,
      masterListGridHeader: PropTypes.shape({}),
      masterListGridItemCount: PropTypes.string,
      masterListPartnershipDistanceUnit: PropTypes.func,
      masterListDistanceUnit: PropTypes.func,
    }),
  }).isRequired,
  mappedMasterListList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  masterListStatusEnum: PropTypes.shape({
    getKeyByValue: PropTypes.func,
  }).isRequired,
  masterListStatusColorEnum: PropTypes.func.isRequired,
  handleMasterListEditButtonClick: PropTypes.func.isRequired,
};
